import {VStack, Text, Show} from 'platform/foundation';

import {isNotNil, isNotNilOrEmpty} from 'ramda-adjunct';

import {FirstLineDetail} from '../types/FirstLineDetail';
import {getCarStyle} from './getCarStyle';
import {roundCubicCapacity} from './roundCubicCapacity';

const getTitle = ({
  make,
  model,
  variant,
  year,
  rowNumber,
  cubicCapacity,
  carStyle,
}: FirstLineDetail = {}) => {
  const translatedMake = typeof make === 'string' ? make : make?.translation;
  const translatedModel = typeof model === 'string' ? model : model?.translation;

  return `${rowNumber ? `${rowNumber}. ` : ''}${
    translatedMake ? `${translatedMake} ` : ''
  }${translatedModel ? `${translatedModel} ` : ''}${
    variant ? `${variant} ` : ''
  }${isNotNil(year) ? `${year} ` : ''}${
    isNotNil(cubicCapacity) ? `${roundCubicCapacity(cubicCapacity)} ` : ''
  }${getCarStyle(carStyle)}`.trim();
};

export const getDetailFirstLine = ({adTitle, ...data}: FirstLineDetail = {}) =>
  isNotNilOrEmpty(adTitle) ? adTitle : getTitle(data);

export const getDetailFirstLineForTooltip = ({adTitle, ...data}: FirstLineDetail = {}) => {
  const title = getTitle(data);

  return (
    <VStack spacing={2}>
      <Show when={isNotNilOrEmpty(adTitle)}>
        <Text color="white" size="small" overflowWrap="anywhere">
          {adTitle}
        </Text>
      </Show>
      <Show when={isNotNilOrEmpty(title)}>
        <Text color="white" size="small" overflowWrap="anywhere">
          ({title})
        </Text>
      </Show>
    </VStack>
  );
};
